import type { Asset, AssetGroup, AssetType, Slide } from '@lumen5/luminary';
import { VideoData } from '@lumen5/luminary';

function getAssetTypeForCopy(asset: Asset) {
    if (VideoData.isAssetGroup(asset)) {
        return VideoData.GROUP_ASSET_TYPE;
    }
    if (VideoData.isTextAsset(asset)) {
        return VideoData.TEXT_ASSET_TYPE;
    }
    if (VideoData.isFancyCaptionAsset(asset)) {
        return VideoData.FANCY_CAPTION_ASSET_TYPE;
    }
    throw new Error(`copyAssetToContainer: unsupported asset type for ${asset.name}`);
}

function addAssetToTargetContainer(
    targetContainer: Slide | AssetGroup,
    assetType: AssetType,
    name: string,
) {
    if (VideoData.isScene(targetContainer)) {
        return targetContainer.addAsset(assetType, { name });
    }
    return targetContainer.addAsset(assetType, { name });
}

export function copyAssetToContainer(
    sourceAsset: Asset,
    targetContainer: Slide | AssetGroup,
): Asset {
    if (VideoData.isAssetGroup(sourceAsset)) {
        const newGroup = addAssetToTargetContainer(
            targetContainer,
            VideoData.GROUP_ASSET_TYPE,
            sourceAsset.name,
        ) as AssetGroup;
        sourceAsset.getAssets({ deep: false }).forEach((child) => {
            copyAssetToContainer(child, newGroup);
        });
        newGroup.load(sourceAsset.save());
        newGroup.generateNewId();
        return newGroup;
    }

    const data = sourceAsset.save();
    const assetType = getAssetTypeForCopy(sourceAsset);

    const newAsset = addAssetToTargetContainer(targetContainer, assetType, sourceAsset.name);
    newAsset.load(data);
    newAsset.generateNewId();
    return newAsset;
}
